namespace GeniuzPOS.InitialData {
    export enum PsPosStationEumConnectDrawerFg {
        ConnectDrawerFgNo = 0,
        ConnectDrawerFgYes = 1
    }
    Serenity.Decorators.registerEnumType(PsPosStationEumConnectDrawerFg, 'GeniuzPOS.InitialData.PsPosStationEumConnectDrawerFg');
}
